import { singlePropReducer } from '../../../utils/reducers';

export const initialState = {
	isLoading: false,
};

const reducers = {
	setIsLoading: singlePropReducer('isLoading'),
};

export default reducers;
